var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsThreeDotsBlack = function SvgIconsThreeDotsBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h3.228v3.228H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.527 11.14a1.615 1.615 0 1 0-2.282 2.284 1.615 1.615 0 0 0 2.282-2.285m-6.362.001a1.615 1.615 0 1 0-2.283 2.284 1.615 1.615 0 0 0 2.283-2.285",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 -1.696 8.97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.472.472a1.615 1.615 0 1 0 2.285 2.283A1.615 1.615 0 0 0 .473.473",
    fill: "#121212",
    mask: "url(#b)"
  })))));
};
export { SvgIconsThreeDotsBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0icmowdXJkYTB3YSIgZD0iTTAgMGgzLjIyOHYzLjIyOEgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMTkuNTI3IDExLjE0YTEuNjE1IDEuNjE1IDAgMSAwLTIuMjgyIDIuMjg0IDEuNjE1IDEuNjE1IDAgMCAwIDIuMjgyLTIuMjg1TTEzLjE2NSAxMS4xNGExLjYxNSAxLjYxNSAwIDEgMC0yLjI4MyAyLjI4NCAxLjYxNSAxLjYxNSAwIDAgMCAyLjI4My0yLjI4NSIgZmlsbD0iIzEyMTIxMiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0icm90YXRlKDkwIC0xLjY5NiA4Ljk3KSI+CiAgICAgICAgICAgIDxtYXNrIGlkPSIwMjBrbHAxY2RiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3JqMHVyZGEwd2EiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8cGF0aCBkPSJNLjQ3Mi40NzJhMS42MTUgMS42MTUgMCAxIDAgMi4yODUgMi4yODNBMS42MTUgMS42MTUgMCAwIDAgLjQ3My40NzMiIGZpbGw9IiMxMjEyMTIiIG1hc2s9InVybCgjMDIwa2xwMWNkYikiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";